import { render, staticRenderFns } from "./EmailInput.vue?vue&type=template&id=264664ea&scoped=true&"
import script from "./EmailInput.vue?vue&type=script&lang=js&"
export * from "./EmailInput.vue?vue&type=script&lang=js&"
import style0 from "./EmailInput.vue?vue&type=style&index=0&id=264664ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264664ea",
  null
  
)

export default component.exports